import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from '@perval/shared';

// Injecte les variables d'environnement dynamiques depuis window.env
function applyEnvFromWindow() {
  // Ne rien faire côté prerender/SSR
  if (typeof window === 'undefined') return;

  const browserEnv = (window as any).env;
  if (!browserEnv) return;

  // Mise à jour des champs existants de l'object environment
  environment.host = window.origin ?? '';
  environment.domain = window.location.hostname ?? '';

  environment.hostname = browserEnv.hostname || 'default';
  environment.baseApiUrl = browserEnv.baseApiUrl || 'default';

  environment.friendlyCaptchaSiteKey = browserEnv.friendlyCaptchaSiteKey || 'default';

  environment.cognito = {
    userPoolId: browserEnv.cognitoUserPoolId || 'default',
    userPoolWebClientId: browserEnv.cognitoUserPoolWebClientId || 'default',
    oauth: {
      domain: browserEnv.cognitoOauthDomain || 'default',
      scope: ['openid', 'email', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: browserEnv.cognitoOauthRedirectSignIn || 'default',
      redirectSignOut: browserEnv.cognitoOauthRedirectSignOut || 'default',
      responseType: browserEnv.cognitoOauthResponseType || 'default',
    },
  };

  environment.freshHost = browserEnv.urlContactFormFreshsales || 'default';
  environment.gtmCode = browserEnv.gtmCode || 'default';
  environment.featureFlag.inscriptionAutonomeEnabled =
    browserEnv.featureFlagInscriptionAutonomeEnabled || false;
}

// Exécuter AVANT Angular
applyEnvFromWindow();
bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
